import { defineComponent as _defineComponent } from 'vue'
import { ref, reactive } from 'vue'
import { useErrorsGetter, useParsedSetter } from '@components/Forms/FormMixin'
import { passwordResetResource } from '@services/authenticate.service'
import useGlobal from '@composables/useGlobal'
import { BASE_URL as profileUrl } from '@router/consts'


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordForgotConfirm',
  props: {
  close: {
    type: Function,
  },
  idToken: {
    type: String,
  },
  token: {
    type: String,
    required: false,
    default: '',
  },
  title: {
    type: String,
    required: false,
    default: '',
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;



const { $t } = useGlobal()

const defaultTitle = $t('Восстановить пароль')

const isLoad = ref(false)
const formdata = reactive({
  two_factor_id: props.idToken,
  token: props.token,
})

const send = async (sendData: object, control: any) => {
  control.setFieldError('non_field_errors', '')

  if (isLoad.value) return

  isLoad.value = true

  passwordResetResource.execute({}, formdata).then(() => {
    const wind: Window = window

    wind.location = profileUrl
  }).catch(async (e: object) => {
    const parsed = await useErrorsGetter(e)

    useParsedSetter(parsed, control.setFieldError)
  }).finally(() => {
    isLoad.value = false
  })
}

const __returned__ = { props, $t, defaultTitle, isLoad, formdata, send, ref, reactive, get useErrorsGetter() { return useErrorsGetter }, get useParsedSetter() { return useParsedSetter }, get passwordResetResource() { return passwordResetResource }, get useGlobal() { return useGlobal }, get profileUrl() { return profileUrl } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})